// removed by extract-text-webpack-plugin
module.exports = {"vpViewFinderContainer":"vpViewFinderContainer___2eUFK","vpViewFinderVideo":"vpViewFinderVideo___3JrAp","vpRecordingIndicatorContainer":"vpRecordingIndicatorContainer___ytswp","vpRecordingDot":"vpRecordingDot___E-I1D","vpCountdown":"vpCountdown___1IEYr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CameraRecord/ViewFinder.module.less
// module id = 3517
// module chunks = 33